import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { SqlDWCopySource } from './sqldw.copysource';
import { DataWarehouseTableDataset } from 'shell-models-lib';

@Metamodel.model({
    name: __IS_FABRIC_DPE__ ? adfModelTypeMap.DataWarehouse.copySourceType : adfModelTypeMap.Warehouse.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(DataWarehouseTableDataset) }
})
export class DataWarehouseCopySource extends SqlDWCopySource { }
